import React from "react";
const InputBox1 = ({ handleChange, ...props }) => {
    return (
        <input type='text' className="address_input_box" onChange={handleChange} {...props} />
    )
}
export default InputBox1;